import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import TagsAnchorContainer from "../TagsAnchorContainer";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicAuthenticateEmail = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Sécurité du compte', link: '/topics/compte/securite'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo='Marche à suivre' titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Il se peut que certaines personnes rédigent de faux e-mails ou créent de faux sites web conçus pour ressembler à ceux de Wodzone. 
              Ces sites peuvent être utilisés pour vous soutirer des informations personnelles, comme votre mot de passe ou vos coordonnées bancaires. 
              Ce type d'attaque est souvent appelé « hameçonnage » ou « usurpation d'identité » ou même « phishing ».
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-56" ref={anchorsParts[0].ref}>
              <p className="help-title-part mb-8">{anchorsParts[0].content}</p>
              <p className="help-text">
                Lorsque vous recevez un e-mail ou si l'on vous redirige vers un site web qui ressemble à Wodzone, mais qui vous demande des informations confidentielles, 
                faites preuve de prudence. En cas de doute, revenez toujours à la page d'accueil de Wodzone sans cliquer sur aucun lien. 
                Saisissez l'adresse<a target='_blank' className="link" href="https://wodzone.onrender.com">https://app.wodzone.fr</a>dans votre navigateur, puis consultez le site depuis cette page.
              </p>
              <p className="help-text mt-24">
                Les e-mails frauduleux intègrent souvent le logo de Wodzone et une fausse adresse Wodzone dans la ligne correspondant à l'expéditeur. 
                Ils peuvent aussi comporter du contenu extrait de vrais e-mails Wodzone, par exemple un message de confirmation de réservation, 
                une confirmation de versement, un rappel d'inscription ou une demande de mise à jour de votre profil. 
                Les fraudeurs donnent un aspect authentique à leurs e-mails. Ils espèrent ainsi vous extorquer des données personnelles que nous ne vous demanderions jamais.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part mb-8">{anchorsParts[1].content}</p>
              <p className="help-text">
                Les e-mails frauduleux peuvent contenir des liens vers de fausses pages web Wodzone pour tenter de subtiliser vos informations. 
                Ne cliquez pas sur les liens contenus dans un e-mail si vous avez le moindre doute quant à son authenticité.
              </p>
              <p className="help-text">
                Un lien Wodzone authentique commence par https://wodzone.onrender.com ou https://wodzone.fr. 
                Si vous cliquez sur un lien qui vous redirige vers une page qui ressemble à Wodzone, mais qui ne commence pas par une adresse valide, 
                il s'agit d'une page frauduleuse que vous devriez fermer.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part mb-8">{anchorsParts[2].content}</p>
              <p className="help-text">
                Les e-mails frauduleux peuvent contenir des liens vers de fausses pages web Wodzone pour tenter de subtiliser vos informations. 
                Ne cliquez pas sur les liens contenus dans un e-mail si vous avez le moindre doute quant à son authenticité.
              </p>
              <p className="help-text">
                Les e-mails frauduleux proviennent souvent de domaines qui peuvent sembler similaires, tels que @wodzon.com ou @wodsone.com 
                En revanche, les e-mails authentiques de Wodzone ne proviendront que des domaines suivants :
              </p>
              <ul className="mb-6">
                <li className="help-text pl-8 mb-8">@wodzone.fr</li>
                <li className="help-text pl-8 mb-8">no-reply@wodzone.fr</li>
              </ul>
              <p className="help-text mt-16">S'ils ne sont pas envoyés depuis l'une de ces adresses, Wodzone n'en est pas l'expéditeur.</p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[3].ref}>
              <p className="help-title-part mb-8">{anchorsParts[3].content}</p>
              <p className="help-text">
                Portez une attention particulière aux fautes d'orthographe dans le nom Wodzone. 
                S'il est mal orthographié dans l'adresse web, cela indique que le site web est frauduleux.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[4].ref}>
              <p className="help-title-part mb-8">{anchorsParts[4].content}</p>
              <p className="help-text">
                Les e-mails et sites frauduleux utilisent souvent un ton alarmiste, évoquant une suspension de compte, une perte d'inscription ou un retard 
                de paiement pour vous inciter à cliquer sur un lien ou fournir des informations rapidement. En cas de doute sur l'authenticité d'un e-mail, 
                connectez-vous directement à votre compte depuis la page d'accueil du site.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[5].ref}>
              <p className="help-title-part mb-8">{anchorsParts[5].content}</p>
              <p className="help-text">
                Si vous pensez avoir consulté une page web conçue pour ressembler à une page Wodzone, faites-le-nous savoir en signalant l'URL du site web 
                à l'adresse suivante : <a target='_blank' className="link" href="#">https://www.wodzone.com/report-phishing.</a>
              </p>
              <p className="help-text">
                Cette page sert uniquement à signaler des sites web suspects : elle ne crée pas de dossier auprès de l'assistance Wodzone ni ne vous 
                envoie de confirmation. Si vous avez eu affaire à un site frauduleux ou si vous avez des questions concernant la sécurité de votre compte, 
                veuillez plutôt<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>nous contacter ici.</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicAuthenticateEmail